import api from "./api";

// Uploads multi-tenant de imagens. Todos autenticados.
// Backend valida ownership via JWT + redimensiona + encoda WebP Q85
// + grava em /data/uploads no Railway.

function formData(file) {
  const fd = new FormData();
  fd.append("file", file);
  return fd;
}

// ─── Guia ───
export async function uploadGuiaHero(guiaId, file) {
  const { data } = await api.post(`/guias/${guiaId}/upload/hero`, formData(file), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

export async function deleteGuiaHero(guiaId) {
  await api.delete(`/guias/${guiaId}/upload/hero`);
}

export async function uploadGuiaPerfil(guiaId, file) {
  const { data } = await api.post(`/guias/${guiaId}/upload/perfil`, formData(file), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

export async function deleteGuiaPerfil(guiaId) {
  await api.delete(`/guias/${guiaId}/upload/perfil`);
}

// ─── Roteiro ───
export async function uploadRoteiroImagem(roteiroId, file) {
  const { data } = await api.post(`/roteiros/${roteiroId}/upload/imagem`, formData(file), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

export async function deleteRoteiroImagem(roteiroId) {
  await api.delete(`/roteiros/${roteiroId}/upload/imagem`);
}

// ─── Depoimento ───
export async function uploadDepoimentoFoto(depoimentoId, file) {
  const { data } = await api.post(`/depoimentos/${depoimentoId}/upload/foto`, formData(file), {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

export async function deleteDepoimentoFoto(depoimentoId) {
  await api.delete(`/depoimentos/${depoimentoId}/upload/foto`);
}
